
import ReactGA from 'react-ga4';

export const initializeGA = () => {
    try {
        ReactGA.initialize('G-4QM3SEEVKS')
    } catch (error) {
        console.error('Error initializing GA', error);
    }
    // ReactGA.initialize('G-4QM3SEEVKS')
}

export const logPageView = (location) => {
    console.log('location',location)
    const path = location && location.pathname || {};
    console.log(path)

    const pageTitleMap = {
        '/': 'Home',
        '/product-list': 'Builder',
        // '/model-transitions': 'Transitions',
        '/resources/warranties': 'Warranties',
        '/resources/definitions': 'Definitions',
       
        // '/categories/air-care': 'All Appliances',
        '/appliances/Cooking': 'All Cooking Appliances',
        '/appliances/Dishwasher': 'All Dishwasher Appliances',
        '/appliances/Laundry': 'All Laundry Appliances',
        '/appliances/Refrigeration': 'All Refrigeration Appliances',
        '/appliances/LG%20Studio': 'All Studio Appliances',
    };
    // Example function to create a title dynamically based on URL structure
    const generateTitleFromPath = (path) => {
        const parts = path.split('/').filter(Boolean); // ['appliances', 'signature', 'WM9500HKA']
        console.log('fparts',parts)
        if (parts[0] === 'appliances' && parts.length > 2) {
            // Specific logic for product pages
            const category = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
            console.log('from title path',category)
            const productCode = parts[2];
            return `${category} - Product ${productCode}`;
        }
        return 'Default Product Page Title'; // Fallback for other paths
    };

    // Determine the page title: use the map or generate dynamically
    const pageTitle = pageTitleMap[path] || generateTitleFromPath(path);

    // Collect additional data for analytics
    const deviceCategory = window.innerWidth <= 768 ? 'mobile' : (window.innerWidth <= 1024 ? 'tablet' : 'desktop'); // Simplified device detection
    const viewportSize = `${window.innerWidth}x${window.innerHeight}`;

    // ReactGA.set({ page: window.location.pathname });
  
    try {
        // ReactGA.pageview(window.location.pathname);
        // const sendHit = 
    ReactGA.send({
        hitType: "pageview",
        page: path,
          location: window.location.href,   // The full URL of the page
            title: pageTitle,               // Use map or generated title
          
            referrer: document.referrer,      // The referrer URL
            host: window.location.hostname,   // The domain/hostname of the page
            screenResolution: `${window.screen.width}x${window.screen.height}`, // The screen resolution
            viewportSize: viewportSize,     // The viewport size
            userLanguage: navigator.language, // The user's browser language
            deviceCategory: deviceCategory, // Simplified device category
            browser: navigator.userAgent,   // User agent for more detail (or parse for specific browser and version)
      
    });

    } catch (error) {
        console.error('Error logging page view', error);
    }
}

// }
export const logEvent = (eventName, parameters = {}) => {
    try {
        ReactGA.event(eventName, parameters);
    } catch (error) {
        console.error('Error logging event', error);
    }
};
